<template>
  <div class="bottombox">
    <div class="boxtop">
        <div class="boxleft">
          <div class="textbox">
            <p class="p">服务类目</p>
            <a class="a">产品设计</a>
            <a class="a">品牌设计</a>
            <a class="a">概念设计</a>
            <a class="a">联合出品</a>
          </div>
          <div class="textbox">
            <p class="p">旗下项目</p>
            <a class="a">周末图书馆</a>
            <a class="a">太空艺术空间</a>
            <a class="a">路边书局</a>
          </div>
          <div class="textbox">
            <p class="p">关于我们</p>
            <a class="a">品牌理念</a>
            <a class="a">发展历程</a>
            <a class="a">团队介绍</a>
            <a class="a">职业发展</a>
          </div>
          <div class="textbox">
            <p class="p">更多资讯</p>
            <a class="a wechathover" >
              <div class="wechatbox">
                <img class="wechat" src="../assets/wechat.jpg">
              </div>
              <svg class="alogo" id="组_2766" data-name="组 2766" xmlns="http://www.w3.org/2000/svg" width="48.684" height="48.684" viewBox="0 0 48.684 48.684">
                <path id="路径_12578" data-name="路径 12578" d="M80.662,105A24.342,24.342,0,1,0,56.32,80.662,24.342,24.342,0,0,0,80.662,105Zm0-3.829a20.513,20.513,0,1,1,20.513-20.513A20.513,20.513,0,0,1,80.662,101.175Z" transform="translate(-56.32 -56.32)" fill="#55939d"/>
                <path id="路径_12579" data-name="路径 12579" d="M281.093,273.667a4.145,4.145,0,1,1,4.145,4.144,1.641,1.641,0,0,0,0,3.282,7.427,7.427,0,1,0-7.427-7.427,1.641,1.641,0,1,0,3.282,0Zm-3.282,11.39a4.145,4.145,0,1,1-4.144-4.145,1.641,1.641,0,0,0,0-3.282,7.427,7.427,0,1,0,7.426,7.427,1.641,1.641,0,0,0-3.282,0Z" transform="translate(-255.026 -255.026)" fill="#55939d"/>
                <path id="路径_12580" data-name="路径 12580" d="M482.857,402.156v11.633h3.282V402.156Z" transform="translate(-460.072 -383.682)" fill="#55939d"/>
              </svg>
            小程序</a>
            <a class="a wechatofficehover">
              <div class="wechatbox1">
                <img class="wechat" src="../assets/wechatoffice.jpg">
              </div>
              <svg class="alogo" xmlns="http://www.w3.org/2000/svg" width="59.789" height="41.621" viewBox="0 0 59.789 41.621">
                <g id="组_2768" data-name="组 2768" transform="translate(0 -127.517)">
                  <path id="路径_12593" data-name="路径 12593" d="M40.478,136.086a22.919,22.919,0,0,0-18.939-8.541C9.655,127.545,0,134.972,0,144.627a15.349,15.349,0,0,0,6.685,12.255L3.342,166.909l11.884-5.942a40.92,40.92,0,0,0,6.685.743h2.971c-1.857-2.228-2.6-5.2-2.971-8.17C21.539,144.256,29.709,137.2,40.478,136.086Zm-14.483,0a1.754,1.754,0,0,1,1.857-1.857h1.485a1.754,1.754,0,0,1,1.857,1.857v1.485a1.754,1.754,0,0,1-1.857,1.857H27.852A1.754,1.754,0,0,1,26,137.572v-1.485Zm-9.655.743a1.754,1.754,0,0,1-1.857,1.857H13a1.754,1.754,0,0,1-1.857-1.857v-1.485A1.754,1.754,0,0,1,13,133.487h1.485a1.754,1.754,0,0,1,1.857,1.857Z" transform="translate(0 0)" fill="#55939d"/>
                  <path id="路径_12594" data-name="路径 12594" d="M481.423,345.8c0-7.056-7.427-13-16.711-13S448,338.742,448,345.8c0,7.427,7.427,13,16.711,13a21.03,21.03,0,0,0,6.685-1.114l10.4,4.828-3.714-9.284A10.008,10.008,0,0,0,481.423,345.8Zm-22.653-2.971a1.754,1.754,0,0,1-1.857,1.857h-1.485a1.754,1.754,0,0,1-1.857-1.857v-1.485a1.754,1.754,0,0,1,1.857-1.857h1.485a1.754,1.754,0,0,1,1.857,1.857Zm15.6,0a1.754,1.754,0,0,1-1.857,1.857h-1.485a1.754,1.754,0,0,1-1.857-1.857v-1.485a1.989,1.989,0,0,1,1.857-1.857h1.485a1.754,1.754,0,0,1,1.857,1.857Z" transform="translate(-422.005 -193.372)" fill="#55939d"/>
                </g>
              </svg>
              公众号</a>
            <a class="a douyinhover" target="_blank">
              <div class="douyin">
                <img class="wechat" src="../assets/douyin.jpg">
              </div>
              <svg class="alogo" xmlns="http://www.w3.org/2000/svg" width="40.159" height="48.193" viewBox="0 0 40.159 48.193">
                <path id="路径_12584" data-name="路径 12584" d="M125.4,19.95a18.243,18.243,0,0,1-10.961-3.662v16.58c0,8.467-6.523,15.324-14.571,15.324S85.3,41.336,85.3,32.869s6.523-15.324,14.571-15.324a13.75,13.75,0,0,1,2.348.2V26.53a6.247,6.247,0,0,0-2.287-.433,6.847,6.847,0,1,0,6.5,6.838V0h8.128a11.19,11.19,0,0,0,10.9,11.46v8.486l-.056,0" transform="translate(-85.3)" fill="#55939d"/>
              </svg>
              抖音</a>
            <a class="a xiaohongshuhover" target="_blank">
              <div class="xiaohongshu">
                <img class="wechat" src="../assets/xiaohongshu.jpg">
              </div>
              <svg class="alogo" xmlns="http://www.w3.org/2000/svg" width="77.492" height="27.469" viewBox="0 0 77.492 27.469">
                <g id="组_2767" data-name="组 2767" transform="translate(-24.261 -42.295)">
                  <path id="路径_12585" data-name="路径 12585" d="M30.9,64.8H25.51a36.419,36.419,0,0,1-1.249,12.356l2.889,5.293C30.977,80.8,30.9,64.8,30.9,64.8" transform="translate(0 -15.472)" fill="#55939d"/>
                  <path id="路径_12586" data-name="路径 12586" d="M89.649,64.8H84.261S84.183,80.8,88.009,82.445L90.9,77.152A36.419,36.419,0,0,1,89.649,64.8" transform="translate(-41.258 -15.472)" fill="#55939d"/>
                  <path id="路径_12587" data-name="路径 12587" d="M48.908,65.423h-3.4c0,3.97,3.358,4.321,3.358,4.321h1.718c3.449,0,3.592-3.944,3.592-3.944V42.295H48.908Z" transform="translate(-14.612)" fill="#55939d"/>
                  <path id="路径_12588" data-name="路径 12588" d="M111.3,54.166h3.511l-2.678,5.466s-1.562,3.071.937,3.176H118.9l2.33-4.23h-2.912a.5.5,0,0,1-.442-.722l4.356-8.532h-5.05l-.3.612h-.335a.5.5,0,0,1-.442-.722l3.627-6.918h-5.05l-4.321,8.694s-1.562,3.072.937,3.176" transform="translate(-58.877 -0.001)" fill="#55939d"/>
                  <path id="路径_12589" data-name="路径 12589" d="M108.764,112.6a1.474,1.474,0,0,1-1.074-.371l-2.616,5.037a1.666,1.666,0,0,0,1.308.585h6.482l2.772-5.251Z" transform="translate(-55.57 -48.093)" fill="#55939d"/>
                  <path id="路径_12590" data-name="路径 12590" d="M151.6,52.991h3.332V47.629H143.012v5.362H146.4V68.349h-5l-2.512,5.063h17.766V68.349H151.6Z" transform="translate(-78.82 -3.668)" fill="#55939d"/>
                  <path id="路径_12591" data-name="路径 12591" d="M214.594,53.281h-.613V49.812a5.881,5.881,0,0,0-5.881-5.881h-2.031V42.3h-5.154v1.635h-3.236v5.258h3.236v4.092h-5.154v5.258h5.154V69.745h5.154V58.539h7.093a1.263,1.263,0,0,1,1.263,1.263v5.521h-4.917a4.422,4.422,0,0,0,4.422,4.422h1.33a4.422,4.422,0,0,0,4.422-4.422V58.37a5.089,5.089,0,0,0-5.089-5.089m-8.525-4.092h1.852a.8.8,0,0,1,.8.8v3.29h-2.654Z" transform="translate(-117.93 -0.001)" fill="#55939d"/>
                  <path id="路径_12592" data-name="路径 12592" d="M260.863,50.18a2.551,2.551,0,1,0-5.1,0v2.551h2.551a2.551,2.551,0,0,0,2.551-2.551" transform="translate(-159.188 -3.668)" fill="#55939d"/>
                </g>
              </svg>
              小红书</a>
          </div>
        </div>
        <div class="boxright">
          <div class="textbox">
            <p class="p1">订阅魔方太空的电子资讯</p>
            <a class="a">订阅即代表您接受魔方太空的隐私政策条款</a>
            <div class="emailbox">
              <input class="email" type = "email" name = "email" placeholder="请输入您的邮箱">
              <input class="submit" type="submit">
            </div>
          </div>
          <div class="textbox">
            <p class="p">联系方式</p>
            <a class="a">邮箱: 3474960894@qq.com</a>
            <a class="a">电话: 18026885072</a>
          </div>
        </div>
    </div>
    <div class="boxbottom">
      <p>Copyright © 2022-2023 univspace.cn All Rights Reserved. </p>
      <div class="linkbox">
        <router-link class="rl" to="/law">法律声明</router-link>
        <a href="https://beian.miit.gov.cn">粤ICP备2022077633号</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.rl{
    font-size: 0.1rem;
    color: rgb(114, 156, 170);
    margin-right: 1rem;
    text-decoration: underline;
}
.p{
  margin-bottom:1.2rem;
}
.p1{
  margin-bottom:0.5rem ;
}
.wechatbox{
  display: none;
  position: relative;
  height: 0rem;
  width: 0rem;
}
.wechatbox1{
  display: none;
  position: relative;
  height: 0rem;
  width: 0rem;
}
.douyin{
  display: none;
  position: relative;
  height: 0rem;
  width: 0rem;
}
.xiaohongshu{
  display: none;
  position: relative;
  height: 0rem;
  width: 0rem;
}
.xiaohongshuhover:hover>>>.xiaohongshu{display: block;}
.douyinhover:hover>>>.douyin{display: block;}
.wechatofficehover:hover>>>.wechatbox1{display: block;}
.wechathover:hover>>>.wechatbox{display: block;}
.wechat{
  position: absolute;
  top: -0.5rem;
  right: 0.5rem;
  height: 8rem;
  width: 8rem;
}
.alo#55939d{
  height: 0.3rem;
}
.alogo{
  width: auto;
  height: 1rem;
  margin-right: 0.5rem;
}

.a{
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: rgb(135, 184, 201);
  margin-bottom: 0.8rem;
  height: 1.5rem;
}
  a{
    font-size: 0.1rem;
    color: rgb(114, 156, 170);
    margin-right: 1rem;
  }
  p{
    font-size: 0.1rem;
    color: rgb(114, 156, 170);
  }
  
  .bottombox{
    position: relative;
    z-index: 10;
    margin: 0;
    width: 100%;
    height: 22rem;
    background-color: rgb(0, 15, 20);
    box-shadow: 0rem 0rem 3rem 0.1rem #00bac7;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .boxtop{
    margin-top: 3% ;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 70%;
    height: 70%;
  }
  .boxleft{
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
  .boxright{
    margin-left: 10%;
    width: 30%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .boxbottom{
    margin-left: 15%;
    margin-bottom: 1%;
    width: 70%;
    align-self: flex-start;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .linkbox{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
    @media screen and (max-width:900px){
    .boxbottom{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }
  }
  .textbox{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: auto;
    height: 100%;
}
  .emailbox{
    width: auto;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .submit{
    height: 100%;
    width: 3rem;
    background-color: black;
    color: rgb(135, 184, 201);
    border-bottom-right-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border: none;
  }
  .submit:active{
    background-color: rgb(0, 15, 20);
  }
  .email{
    background-color: black;
    border: none;
    color: rgb(135, 184, 201);
    height: 1.8rem;
    width: 12rem;
    border-bottom-left-radius: 0.5rem;
    border-top-left-radius: 0.5rem;
  }
@media screen and (max-width:1200px) {
  .bottombox{
    height: 30rem;
  }
  .boxleft{
    width: 100%;
    height: 60%;
  }
  .boxright{
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    margin-left: 0;
    width: 100%;
    height: 35%;
  }
  .boxtop{
    height: 90%;
    flex-direction: column;
  }

}
</style>